module.exports = __webpack_public_path__ + "img/main_technic_2.fee67bad.jpg";